class r extends Error{constructor(r){super(r),this.name=this.constructor.name,Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor)}}export{r as default};
